import React, { Fragment } from 'react';

import { IconButtonProps, Theme } from '@material-ui/core';
import { makeStyles, createStyles } from '@material-ui/styles';
import { Button, IconButton } from '@material-ui/core';

interface WithoutVariant2 extends IconButtonProps { dense: boolean };

function MapButton({ dense, ...otherProps }: WithoutVariant2) {
  const classes = useStyles();

  return (
    <Fragment>
      {dense ? (
        <IconButton
          classes={{ root: classes.rootDense }}
          {...otherProps}
        />
      ) : (
        <Button
          classes={{ root: classes.root }}
          variant="contained"
          {...otherProps}
        />
      )}
    </Fragment>
  );
}

const useStyles = makeStyles((theme: Theme) => createStyles({
  root: {
    backgroundColor: theme.palette.background.dark + ' !important',
    color: theme.palette.grey.variant3,
    borderRadius: theme.constants.radius.sm,
    width: theme.constants.mapButton,
    height: theme.constants.mapButton,
    padding: 0,
    minWidth: 'initial'
  },
  rootDense: {
    backgroundColor: theme.palette.background.dark + ' !important',
    color: theme.palette.text.primary,
    width: theme.constants.mapButtonDense,
    height: theme.constants.mapButtonDense,
    padding: 0,
    pointerEvents: 'all'
  }
}))



export default MapButton;
